import { AccordionDetails as BaseAccordionDetails } from '@mui/material';
import { styled, Button, Icon } from '@innowise-group/mui-kit';
import { LabeledSwitch as LabeledSwitchMui } from '@shared-mui-components';

export const Wrapper = styled.div`
  & .MuiFormControlLabel-root {
    padding: 0 0.5rem;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  gap: 1rem;
`;

export const SettingButton = styled(Button)`
  &.MuiButton-root.MuiButton-contained {
    justify-content: space-between;
    background-color: ${({ theme }) => theme.palette.general.darkGrey[70]};
    &:hover {
      background-color: ${({ theme }) => theme.palette.general.darkGrey[60]};
    }
  }
`;

const baseColorSelect = ({ theme }) => theme.palette.general.darkGrey[60];

export const ExportButton = styled(Button)`
  & .MuiCircularProgress-root {
    margin: 0;
  }
  &.MuiButton-root.MuiButton-outlined {
    margin-left: auto;
    color: ${baseColorSelect};
    border-color: ${baseColorSelect};
    & svg {
      fill: ${baseColorSelect};
    }
    &:hover {
      fill: ${({ theme }) => theme.palette.general.darkGrey[80]};
      color: ${({ theme }) => theme.palette.general.darkGrey[80]};
      border-color: ${({ theme }) => theme.palette.general.darkGrey[80]};
      & svg {
        fill: ${({ theme }) => theme.palette.general.darkGrey[80]};
      }
    }
  }
`;

export const ArrowIcon = styled(Icon).attrs({
  type: 'u_angle-down',
})<{ open: boolean }>`
  transform: ${({ open }) => (open ? 'rotate(180deg)' : 'rotate(0deg)')};
  transition: transform 0.3s;
`;

export const AccordionDetails = styled(BaseAccordionDetails)`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 1.5rem;
  gap: 0.625rem;
  margin-top: 1rem;
  border-radius: 0.5rem;
  background: ${({ theme }) => theme.palette.general.lightGrey[40]};
  &.MuiAccordionDetails-root {
    padding: 1rem;
  }
`;

export const FiltersContainer = styled.div`
  display: grid;
  gap: 1.2rem;
  width: 100%;
  margin-top: 10px;
  grid-template: repeat(2, auto) / repeat(4, 1fr);
`;

export const PeriodText = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ theme }) => theme.fonts.primary[50]};
  color: ${({ theme }) => theme.palette.general.darkGrey[60]};
`;

export const ReportsButtonsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  justify-content: space-between;
  gap: 3rem;
`;

export const ReportsButtonsFilters = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  gap: 1.5rem;
`;

export const LabeledSwitch = styled(LabeledSwitchMui)`
  &.MuiSwitch-root {
    width: 46px;
    height: 24px;
    border-radius: 24px;
  }

  & .MuiSwitch-input {
    height: 24px;
  }

  & .MuiSwitch-switchBase {
    padding: 0;
    top: 50%;
    transform: translateY(-50%);
    left: 1px;
    transition: transform 0.2s;

    &.Mui-checked {
      right: 4px;
      transform: translateX(12px) translateY(-50%);
    }
  }
`;

export const ReportsButtons = styled.div`
  display: flex;
  align-items: center;
  gap: 1.25rem;
  justify-content: end;
`;

export const ReportsTypeButtons = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const SubmitButton = styled(SettingButton)`
  max-height: 40px;
  grid-area: c;
  &.MuiButton-root.MuiButton-contained {
    justify-content: center;
    &:disabled {
      background-color: ${({ theme }) => theme.palette.general.darkGrey[60]};
      border-color: ${({ theme }) => theme.palette.general.darkGrey[60]};
    }
  }
`;
